import Loader from "components/DesignSystem/Loader/loader";
import {
  CHAT_CARD_TYPE,
  ESIGN_REQUEST_CUSTOM_TYPE,
  MERCHANT_EMAIL_REQUEST_CUSTOM_TYPE,
  OPEN_ITEM_CUSTOM_TYPE,
  REQUESTED_ANSWERS_CUSTOM_TYPE,
  REQUESTED_DOCUMENTS_CUSTOM_TYPE,
  REQUESTED_INFO_CUSTOM_TYPE,
  REQUESTED_REVIEW_DRAFT_TYPE,
  REQUESTED_DFT_REVIEW_TYPE,
  SENSITIVE_DATA_CUSTOM_TYPE,
  PRICED_TICKET_CARD,
  ACCOUNTANT_ACCESS_REQUEST_CARD_TYPE,
} from "constants/chatType";
import { usePaginatedMessages } from "hooks/usePaginatedMessages";
import { useDispatch } from "react-redux";
import { openActionCentreSlider } from "store/slices/channelInfoSlider";
import { useChannelStateContext, useChatContext } from "stream-chat-react";
import { ChannelInfoWrapper } from "../ChannelInfoWrapper";
import { ActionCentreList } from "./ActionCentreList";

export const ActionCentre = ({
  groupId,
  alignToCenter,
}: {
  groupId: string;
  alignToCenter?: boolean;
}) => {
  const { client } = useChatContext();
  const { channel } = useChannelStateContext();
  const dispatch = useDispatch();

  const {
    messages: actionMessageItems,
    loadNextPage,
    next,
    loading,
  } = usePaginatedMessages(
    client,
    {
      id: channel.id,
    },
    {},
    { limit: 100 },
    {
      custom_type: {
        $in: [
          CHAT_CARD_TYPE,
          OPEN_ITEM_CUSTOM_TYPE,
          REQUESTED_DOCUMENTS_CUSTOM_TYPE,
          REQUESTED_INFO_CUSTOM_TYPE,
          SENSITIVE_DATA_CUSTOM_TYPE,
          REQUESTED_ANSWERS_CUSTOM_TYPE,
          ESIGN_REQUEST_CUSTOM_TYPE,
          REQUESTED_REVIEW_DRAFT_TYPE,
          REQUESTED_DFT_REVIEW_TYPE,
          MERCHANT_EMAIL_REQUEST_CUSTOM_TYPE,
          PRICED_TICKET_CARD,
          ACCOUNTANT_ACCESS_REQUEST_CARD_TYPE,
        ],
      },
      card_status: { $eq: "REQUESTED" },
    }
  );

  if (loading) {
    return (
      <ChannelInfoWrapper
        title={<div className="t-text-subtext">Action centre</div>}
        openDetails={() => {}}
      >
        <div className="t-max-h-32 t-flex t-justify-center t-items-center">
          <Loader />
        </div>
      </ChannelInfoWrapper>
    );
  }

  return (
    <ChannelInfoWrapper
      title={
        <div className="t-text-subtext t-flex t-gap-1 t-items-center">
          Action Centre{" "}
          {Boolean(actionMessageItems.length) && (
            <div className="t-bg-red t-text-surface t-flex t-items-center t-justify-center t-text-caption t-rounded-full t-min-w-4 t-min-h-4 t-max-w-4 t-max-h-4">
              {actionMessageItems.length}
            </div>
          )}
        </div>
      }
      openDetails={() => dispatch(openActionCentreSlider())}
    >
      <ActionCentreList
        //  @ts-ignore
        actionMessageItems={actionMessageItems.map((ticket) => ({
          message: {
            ...ticket.message,
            custom_data: ticket.message.custom_data || {},
          },
        }))}
        loadNextPage={loadNextPage}
        next={Boolean(next)}
        groupId={groupId}
        emptyStateText="No actions"
        alignToCenter={alignToCenter}
      />
    </ChannelInfoWrapper>
  );
};
